export default {
  name: '名字',
  tel: '联系电话',
  save: '保存',
  confirm: '确认',
  cancel: '取消',
  delete: '删除',
  complete: '完成',
  contact: '联系人',
  loadingTip: '加载中...',
  nameEmpty: '请填写名字',
  confirmDelete: '确定要删除么',
  telInvalid: '请填写正确的联系电话',
  telPlaceholder: '手机或固定电话',
  vanContactCard: {
    addText: '添加订单联系人信息'
  },
  vanContactList: {
    addText: '新建联系人'
  },
  vanPagination: {
    prev: '上一页',
    next: '下一页'
  },
  vanPullRefresh: {
    pulling: '下拉即可刷新...',
    loosing: '释放即可刷新...'
  },
  vanSubmitBar: {
    label: '合计：'
  },
  vanCouponCell: {
    title: '优惠券',
    tips: '使用优惠',
    count: function count(_count) {
      return '\u60A8\u6709 ' + _count + ' \u4E2A\u53EF\u7528\u4F18\u60E0';
    }
  },
  vanCouponList: {
    empty: '暂无优惠券',
    exchange: '兑换',
    close: '不使用优惠',
    disabled: '不可用优惠',
    placeholder: '请输入优惠码'
  },
  vanCouponItem: {
    unlimited: '无使用门槛',
    discount: function discount(_discount) {
      return _discount + '\u6298';
    },
    condition: function condition(_condition) {
      return '\u6EE1' + _condition + '\u5143\u53EF\u7528';
    }
  },
  vanAddressEdit: {
    area: '收件地区',
    receiver: '收货人',
    postal: '邮政编码',
    areaEmpty: '请选择收件地区',
    addressEmpty: '请填写详细地址',
    postalEmpty: '邮政编码格式不正确',
    defaultAddress: '设为默认收货地址'
  },
  vanAddressEditDetail: {
    label: '详细地址',
    placeholder: '如街道、楼层、门牌号等'
  },
  vanAddressList: {
    address: '收货地址',
    add: '新增收货地址'
  },
  vanSku: {
    unavailable: '商品已经无法购买啦',
    spec: '请先选择商品规格',
    least: '至少选择一件',
    quota: function quota(_quota) {
      return '\u9650\u8D2D' + _quota + '\u4EF6';
    },
    inventory: '库存不足',
    purchase: function purchase(count) {
      return '\u60A8\u5DF2\u8D2D\u4E70' + count + '\u4EF6';
    }
  },
  vanSkuActions: {
    cart: '加入购物车',
    buy: '立即购买'
  },
  vanSkuMessages: {
    fill: '请填写',
    upload: '请上传',
    number: '请填写正确的数字格式留言',
    email: '请填写正确的邮箱',
    id_no: '请填写正确的身份证号码',
    onePic: '仅限一张',
    placeholder: {
      id_no: '输入身份证号码',
      text: '输入文本',
      tel: '输入数字',
      email: '输入邮箱',
      date: '点击选择日期',
      time: '点击选择时间',
      textarea: '点击填写段落文本'
    }
  },
  vanSkuImgUploader: {
    or: '或',
    uploading: '正在上传...',
    rephoto: '重拍',
    photo: '拍照',
    reselect: '重新选择照片',
    select: '选择照片',
    maxSize: function maxSize(_maxSize) {
      return '\u6700\u5927\u53EF\u4E0A\u4F20\u56FE\u7247\u4E3A' + _maxSize + 'MB\uFF0C\u8BF7\u5C1D\u8BD5\u538B\u7F29\u56FE\u7247\u5C3A\u5BF8';
    }
  },
  vanSkuStepper: {
    title: '购买数量',
    remain: function remain(count) {
      return '\u5269\u4F59' + count + '\u4EF6';
    },
    quota: function quota(_quota2) {
      return '\u6BCF\u4EBA\u9650\u8D2D' + _quota2 + '\u4EF6';
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/locale/lang/zh-CN.js
// module id = 231
// module chunks = 81